import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { PagedCollectionQuery, PagedCollectionQueryResult } from '../common/query/paged-collection-query';


export interface PkwiuCollectionItem {
    readonly description: string;
    readonly id: number;
    readonly name: string;
}

export class PkwiuPagedCollectionQuery extends PagedCollectionQuery<PkwiuCollectionItem> { }

export class PkwiuPagedCollectionQueryHandlerBase implements QueryHandler<PkwiuPagedCollectionQuery, PagedCollectionQueryResult<PkwiuCollectionItem>> {
    private static Url = TaggedUrl.join('system/pkwiu', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(query: PkwiuPagedCollectionQuery): Promise<PagedCollectionQueryResult<PkwiuCollectionItem>> {
        const { data } = await this.$http.get<PagedCollectionQueryResult<PkwiuCollectionItem>>(PkwiuPagedCollectionQueryHandlerBase.Url, {
            params:  { ...query.params }
        });
        const items = data.items.map(i => {
            return {
                id: i.id,
                name: i.name,
                description: i.description
            };
        });
        return {
            items: items,
            totalItemsCount: data.totalItemsCount
        };
    }
}
